<!--初期ログイン_パスワード変更画面-->
<template>
  <div>
    <div class="i0012-top-warn">
      {{$t('MODULE.I0012_LBL_TOP_WARN')}}
    </div>
    <div style="background-color:#fafafa; ">
      <el-row :gutter="0" style="text-align:center">
        <!-- パスワード変更 -->
        <div class="table-header"><span>{{$t('MODULE.I0012_LBL_PASSWORD_CHANGE')}}</span></div>
        <table class="i0012-table table-label">
          <!-- 新パスワード -->
          <tr>
            <td class="i0012-form-label" style="line-height:30px">
              <span>{{$t('MODULE.I0012_LBL_NEW_PASSWORD')}}</span>
            </td>
            <td>
              <el-input type="password" class="i0012-input" v-model="newPassword"></el-input>
            </td>
          </tr>
          <!-- 新パスワード(確認) -->
          <tr>
            <td class="i0012-form-label" style="line-height:30px">
              <span>{{$t('MODULE.I0012_LBL_NEW_PASSWORD_CONFIRM')}}</span>
            </td>
            <td>
              <el-input type="password" class="i0012-input" v-model="newPasswordAffirm"></el-input>
            </td>
          </tr>
        </table>
      </el-row>
    </div>
    <div align="center" style=" margin-top:3px">
      <div class="i0012-bottom-warn">{{$t('MODULE.I0012_LBL_BOTTOM_WARN')}}</div>
      <!-- 申請 -->
      <el-button class="css-btn css-button" @click="i0012ApplicationOnClick" type="primary">{{$t('MODULE.I0012_LBL_CHANGE')}}</el-button>
    </div>
  </div>
</template>
<script>
let url = require('@/../config/sysConfig')
import css from "@/statics/css"
import * as amsApi from "../api/i_0012"
export default {
  mixins: [css],
  data() {
    return {
      newPassword: '',
      newPasswordAffirm: '',
    };
  },
  methods: {
    //input入力チェック
    i0012ApplicationOnClick() {
      let re = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/);
      if (!re.test(this.newPassword)) {
        this.$message.error({ message: this.$t('COMMON.MSG_PWRESET_VALIDITY'), showClose: true });
        return
      }
      if (this.newPassword != this.newPasswordAffirm) {
        this.$message.error({ message: this.$t('COMMON.MSG_NEWPW_VALIDITY'), showClose: true });
        return
      }
      this.passwordUpdate()
    },
    //パスワード変更
    passwordUpdate() {
      var params = {}
      params.userId = JSON.parse(localStorage.getItem('userInfo')).userCd
      params.password = this.newPassword
      params.oneTimePwFlag = '0'
      amsApi.pwChange(params).then(res => {
        if (res.code == '202') {
          //変更成功
          this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true });
          this.$store.commit('passwordUpdate', '1')
          this.newPasswordAffirm = ''
          this.newPassword = ''
          this.loginCheck(params.userId, params.password)
          //遷移先判定
          this.menuStateManagerGet(params.userId)
        } else if (res.code == '311') {
          //変更失敗
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
        }
      });

    },
    //誓約・同意画面を表示する
    menuStateManagerGet(userId) {
      amsApi.menuStateManagerGet(userId).then(res => {
        if (res.code == 204) {
          var i0011UsedNum = res.items.menuState[0].i0011Used
          if (i0011UsedNum == 1) {
            this.$router.push({ path: url.routerUrl_I0011 })
          } else {
            this.noticeDetailSearch(userId)
          }
        }
      }).catch((err) => {

      });
    },
    //お知らせ一覧画面を表示する
    noticeDetailSearch(userId) {
      amsApi.noticeDetailSearch(userId).then(res => {
        if (res.code == '204') {
          for (var item of res.items.tNoticeDetail) {
            if (item.confirmFlag == 0) {
              this.$router.push({ path: url.routerUrl_B0001 })
              return
            } else {
              this.$router.push({ path: url.routerUrl_S0001 })
            }
          }
        } else if (res.code == '300') {
          this.$router.push({ path: url.routerUrl_S0001 })
        }
      });
    },
    //token再取得
    loginCheck(userId, password) {
      let loginParams = { userCd: userId, password: password }
      amsApi.login_check(loginParams).then(res => {
        if (res.code != '200') {
          this.$message.error({ message: this.$t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'), showClose: true });
          return
        }
      }).catch(err => {
        this.$message.error({ message: this.$t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'), showClose: true });
      });
    }
  }
}

</script>
<style >
/* 紅枠様式 */
.i0012-top-warn {
  border: red solid 1px;
  width: 97%;
  margin: 5px auto;
  padding: 3px;
  color: red;
  line-height: 25px;
}
.i0012-bottom-warn {
  margin: 15px;
  text-align: left;
  color: red;
  line-height: 20px;
  font-size: 13px;
}
/* form様式 */
.i0012-form-label {
  text-align: right;
  width: 120px;
  background: #d2eef8;
}
/* input様式 */
.i0012-input .el-input__inner {
  padding: 0 12px 0px 12px;
  font-size: 12px;
}
/* 表格边框、字体样式 */
.i0012-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0012-table,
.i0012-table tr td {
  border: 1px solid #ccc;
}
/* 表格内边距 */
.i0012-table td {
  padding: 5px 8px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0012.vue